import MasterProductManagementModule from "@/modules/MasterProductManagement";

function MasterProductManagementPage() {
  return <MasterProductManagementModule />;
}

export default MasterProductManagementPage;
